'use client';

import * as React from 'react';
import { motion } from 'motion/react';

export type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  y?: number;
};

// Scroll-triggered entrance used across the marketing pages: fade + rise once
// the element scrolls into view.
export function Reveal({
  children,
  className,
  delay = 0,
  y = 24
}: RevealProps): React.JSX.Element {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.5, delay, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  );
}
